// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","button--bold":"Button_button--bold__3wcvl","button--cancel":"Button_button--cancel__DC_K_","button--rounded":"Button_button--rounded__1kCpa"};